/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLocation } from 'react-use';
import { DataNotFound } from '../../../components/DataNotFound';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import { getAsync, postAsync, reactURL } from '../../../components/helper/axiosHelper';
import { updatedCart } from '../../../features/updatedCartSlice';
import { addToCart } from '../../../features/usercartSlice';
import { PageHitCountApi } from '../../../shared/Helper';
import { addTitle } from '../../../features/campaignMenuSlice';
import copy from 'copy-to-clipboard';
import BannerImg from '../../../../public/assets/images/BannersFiles/27.jpg';
import LoadingAnimation from '../../../components/LoadingAnimation';
import LoaderModal from '../../../components/common/LoaderModal';
import ModalCartSuccessful from '../../../components/elements/ModalCartSuccessfull';
import ProjectsCard from '../../../components/elements/ProjectsCard';
import SMSModal from '../../../components/elements/SMSModal';
import StaticBanner from '../../../components/elements/StaticBanner';
import CampaignsCard from '../../../components/elements/CampaignsCard';
// import BannerImg from '../../../../public/assets/images/BannersFiles/31.jpg';

export const CampaignDonation = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const Mainmenu = useSelector((state) => state.campaignMenu.menu);
  const [value, setValue] = useState([]);
  const [modalMessageText, setModalMessageText] = useState('');
  const [modalExist, setModalExist] = useState(false);
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [epUserID, setEpUserID] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentMethodId, setPaymentMethodId] = useState(1);
  const [projectGuID, setprojectGuID] = useState('');
  const [errorStates, setErrorStates] = useState([]);
  const [amount, setAmount] = useState(0);
  const [count, setCount] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [previousIndex, setPreviousIndex] = useState(currentIndex);
  const [smsModal, setSmsModal] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [projectId, setProjectId] = useState('');

  const token = localStorage.getItem('token');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { id } = useParams();
  const { t } = useTranslation();
  const parts = pathname.split('/');
  parts.pop();
  const newPath = parts.join('/') + '/';

  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, [id]);

  useEffect(() => {
    localStorage.setItem('isHome', true);
    const fetchData = async () => {
      setValue(null);
      setLoading(true);
      try {
        await getAsync(`APIClient/CampaignProjectSHJC?ModuleId=${id}`).then((response) => {
          const result = response;
          setValue(result);
          setLoading(false);
        });
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]);

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
  }, [epUserID]);

  useEffect(() => {
    if (value?.data && value?.data?.length > 0) {
      setSelectedValues(Array(value?.data?.length).fill(1)); // Default to One Time selected
    }
  }, [value?.data]);

  useEffect(() => {
    (async () => {
      const response = await getAsync('APIClient/CampaignModuleTypesSHJC');
      if (response) {
        dispatch(addTitle(response?.data));
      }
    })();
    localStorage.setItem('isHome', newPath != `/user/CampaignDonation/` ? true : false);
  }, []);
  const dataObject = {
    paymentMethodId,
    amount,
  };
  const updateErrorState = (index, isError) => {
    setErrorStates((prevStates) => {
      const newErrorStates = [...prevStates];
      newErrorStates[index] = isError;
      return newErrorStates;
    });
  };

  // Function to handle donation
  const DonateHandle = (currentIndex, i, id, price, referralLink, isContribution, projectTypeIdInt) => {
    let selectedAmount = currentIndex == i ? Number(amount) : 0;
    // let selectedAmount = currentIndex !== i ? price : amount;

    if (selectedAmount > 0) {
      if (selectedAmount == 0) {
        updateErrorState(isContribution, true);
        return;
      } else {
        updateErrorState(isContribution, false);
        const payload = {
          ...dataObject,
          amount: selectedAmount,
          isContribution,
        };
        const link = `/externalPayment/${id}/${referralLink}/11/${projectTypeIdInt}`;
        navigate(link, { state: { paymentInfo: payload } });
      }
    } else {
      toast.error(`${t('Amount must be greater than 0')}`);
    }
  };

  if (loading) return <LoadingAnimation styling={' h-screen'} />;

  const addCartItem = async (currentIndex, i, price, pId, projectTypeIdInt) => {
    try {
      let selectedAmount = currentIndex == i ? Number(amount) : 0;
      // let selectedAmount = currentIndex !== i ? price : amount;
      if (selectedAmount > 0) {
        if (selectedAmount !== 0) {
          setIsLoading(true);
          const res = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
          dispatch(addToCart(res?.data));
          const response = await postAsync(`APIClient/ProjectListGUID`, [
            { ProjectId: pId, ProjectTypeIdInt: projectTypeIdInt },
          ]);
          // if (response.statusCode) {
          //   setModalMessageText('Item not added in cart');
          //   setModalExist(true);
          //   setGridModalOpen(true);
          // }
          if (response) {
            setIsLoading(false);
          }
          const newItem = response?.data;
          const cartbody = {
            cartID: 0,
            projectName: newItem[0]?.titleAr || newItem[0]?.titleEn,
            epUserID: epUserID,
            ip: 'string',
            projectID: newItem[0]?.id,
            amount: selectedAmount,
            projectTypeIdInt,
          };
          if (token && res?.statusCode === 204) {
            await postAsync(`Cart/CreateCart`, cartbody);
            const resp = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
            dispatch(addToCart(resp?.data));
            dispatch(updatedCart(true));
            setModalMessageText('Add to cart Successfully');
            setModalExist(false);
            setGridModalOpen(true);
            return;
          } else if (res.data?.length && res?.statusCode === 200) {
            const itemExistsdatabase = res?.data?.some((item) => item.projectID === pId);

            if (token && !itemExistsdatabase) {
              await postAsync(`Cart/CreateCart`, cartbody);
              const respo = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, {
                EPUserID: epUserID,
              });
              dispatch(addToCart(respo?.data));
              dispatch(updatedCart(true));
              setModalMessageText('Add to cart Successfully');
              setModalExist(false);
              setGridModalOpen(true);
            } else {
              setModalMessageText('Item  Already Exists');
              setModalExist(true);
              setGridModalOpen(true);
            }
          }

          if (!token) {
            const updateCart = (data) => {
              const updatedData = data.map((item) => {
                if (item?.id === newItem[0].id) {
                  return { ...item, price: selectedAmount };
                }
                return item;
              });
              localStorage.setItem('cart', JSON.stringify(updatedData));
            };

            // Retrieve existing cart data or create an empty array
            const existingData = JSON.parse(localStorage.getItem('cart')) || [];
            // Check if item exists and update price if needed
            const itemExists = existingData.some((item) => item?.id === newItem[0]?.id);
            if (itemExists) {
              setModalMessageText('Item  Already Exists');
              setModalExist(true);
              setGridModalOpen(true);
              updateCart(existingData);
            } else {
              // toast.success('Add to cart Successfully');
              dispatch(updatedCart(true));
              newItem[0].price = selectedAmount;
              newItem[0].projectTypeIdInt = projectTypeIdInt;
              updateCart([...existingData, ...newItem]);
              setModalMessageText('Add to cart Successfully');
              setModalExist(false);
              setGridModalOpen(true);
            }
          }
        } else {
          setprojectGuID(pId);
        }
      } else {
        toast.error(`${t('Amount must be greater than 0')}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleShareLink = (guid, projectTypeIdInt) => {
    setIsLoading(true);
    const shareLink = `${reactURL}/PaymentProcess/` + guid + '/' + guid + '/' + 11 + '/' + projectTypeIdInt;
    copy(shareLink);
    toast.success(t('Link copy Successfully'));
    setIsLoading(false);
  };
  const handleOnChange = (index, value) => {
    const newSelectedValues = [...selectedValues];
    newSelectedValues[index] = value;
    setSelectedValues(newSelectedValues);
    setPaymentMethodId(value);
  };

  return (
    <>
      {true ? (
        <div className="">
          {Mainmenu?.map((data) => {
            if (data?.moduleID == +id) {
              return (
                <StaticBanner
                  BannerImg={BannerImg}
                  // picture={data?.picture}
                  picture={BannerImg}
                  ar_SA={data?.title_AR}
                  en_US={data?.title_EN}
                  arabic={true}
                />
              );
            }
          })}

          <div className="container-fluid py-5 justify-center">
            <div className="row px-4 sm:px-5 md:px-5 lg:px-5  justify-center">
              {/*news box 1 */}
              {value?.data?.length > 0 ? (
                value?.data?.map((data, i) => {
                  return (
                    // <>
                    //   <div
                    //     data-aos="zoom-in"
                    //     data-aos-once="true"
                    //     key={i}
                    //     className="  bg-white border m-1 w-96 my-3 border-gray-200 rounded-3xl shadow  px-3"
                    //   >
                    //     <div className="py-1 justify-center hover:scale-105 transition-transform duration-300">
                    //       <div className={`flex justify-between text-center  ${isActive ? 'pl-12' : 'pr-12'}`}>
                    //         <ShareIcon
                    //           onClick={() => handleShareLink(_?.id)}
                    //           className={`w-7 h-7 items-center cursor-pointer text-customgreen hover:text-hovergreen m-3 transition-colors duration-700 ${isActive ? 'rotate-180' : ''}`}
                    //         />

                    //         <div className={`flex   justify-center items-center  w-full `}>
                    //           <h3 className="capitalize truncate text-wrap font-semibold text-customgreen">
                    //             {isActive
                    //               ? _?.title_AR.length > 15
                    //                 ? `${_?.title_AR.slice(0, 15)}...`
                    //                 : _?.title_AR
                    //               : _.title_EN.length > 15
                    //                 ? `${_.title_EN.slice(0, 15)}...`
                    //                 : _.title_EN}
                    //             {/* {data?.templateName} */}
                    //           </h3>
                    //         </div>
                    //       </div>
                    //       <img
                    //         className="w-full h-32 mx-auto rounded-t-2xl"
                    //         src={`data:image/jpeg;base64,
                    //           ${_?.picture != null && _?.picture !== '' ? _?.picture : defaultImage}`}
                    //         alt="project Name"
                    //       />

                    //       {_?.isContribution === true && (
                    //         <div className="relative w-full h-6 bg-gray-200 ">
                    //           <div
                    //             className={`absolute top-0 ${isActive ? 'right-0' : 'left-0'} h-full text-center   ${_?.receivedPercentage === 0 ? ' text-black' : 'text-white'} bg-customgreen `}
                    //             style={{ width: `${_?.receivedPercentage}%` }}
                    //           >
                    //             {_?.receivedPercentage}%
                    //           </div>
                    //         </div>
                    //       )}

                    //       <div className={`space-y-4 ${_?.isAltakamul ? '' : 'pb-3'}`}>
                    //         {_?.isRecurring && (
                    //           <div className="flex gap-3 justify-between">
                    //             {/* One Time Payment Radio Button */}
                    //             <div
                    //               onClick={() => handleOnChange(i, 1)}
                    //               className={`w-full cursor-pointer flex items-center border-2 ${
                    //                 selectedValues[i] === 1
                    //                   ? 'border-customgreen dark:border-customgreen bg-green-50 shadow-md'
                    //                   : 'border-gray-200'
                    //               } rounded-full dark:border-gray-700 p-2`}
                    //             >
                    //               <input
                    //                 onChange={(e) => {
                    //                   handleOnChange(i, 1);
                    //                   console.log(
                    //                     `Radio button value: ${e.target.value}, Checked: ${e.target.checked}`,
                    //                   );
                    //                 }}
                    //                 id={`bordered-radio-1-${i}`}
                    //                 type="radio"
                    //                 value={1}
                    //                 name={`payment-${i}`}
                    //                 className="text-customgreen text-sm cursor-pointer rounded-lg focus:ring-customgreen focus:border-customgreen block"
                    //                 checked={selectedValues[i] === 1} // Use checked for controlled input
                    //               />
                    //               <label
                    //                 htmlFor={`bordered-radio-1-${i}`}
                    //                 className="w-full ms-2 text-sm cursor-pointer font-medium"
                    //               >
                    //                 {t('One Time')}
                    //               </label>
                    //             </div>

                    //             {/* Monthly Payment Radio Button */}
                    //             <div
                    //               onClick={() => handleOnChange(i, 2)}
                    //               className={`w-full cursor-pointer flex items-center border-2 ${
                    //                 selectedValues[i] === 2
                    //                   ? 'border-customgreen dark:border-customgreen bg-green-50 shadow-md'
                    //                   : 'border-gray-200'
                    //               } rounded-full dark:border-gray-700 p-2`}
                    //             >
                    //               <input
                    //                 onChange={(e) => {
                    //                   handleOnChange(i, 2);
                    //                   console.log(
                    //                     `Radio button value: ${e.target.value}, Checked: ${e.target.checked}`,
                    //                   );
                    //                 }}
                    //                 id={`bordered-radio-2-${i}`}
                    //                 type="radio"
                    //                 value={2}
                    //                 name={`payment-${i}`}
                    //                 className="text-customgreen text-sm cursor-pointer rounded-lg focus:ring-customgreen focus:border-customgreen block"
                    //                 checked={selectedValues[i] === 2} // Use checked for controlled input
                    //               />
                    //               <label
                    //                 htmlFor={`bordered-radio-2-${i}`}
                    //                 className="w-full ms-2 text-sm cursor-pointer font-medium"
                    //               >
                    //                 {t('Monthly')}
                    //               </label>
                    //             </div>
                    //           </div>
                    //         )}

                    //         <div>
                    //           <p className="my-3 text-sm text-center truncate  tracking-tight text-gray-900 ">
                    //             {isActive ? _?.details_AR : _?.details_EN}
                    //           </p>
                    //           <h5 className="md:my-3 my-2 text-md text-center text-sm font-bold tracking-tight text-gray-900 ">
                    //             {' '}
                    //             {t('Total Cost')} <span className={isActive ? 'mr-2' : 'ml-2'}>:</span>
                    //             <span className={`ml-2 text-customorange font-bold ${isActive ? 'mr-2' : 'ml-2'}`}>
                    //               {_.price}
                    //             </span>
                    //             <span className={` mx-2 font-bold`}>{t('AED')}</span>
                    //           </h5>
                    //         </div>
                    //         <div className="space-y-4">
                    //           <div className="flex flex-col sxx:flex-row-reverse sm:flex-row-reverse md:flex-row-reverse lg:flex-row-reverse xl:flex-row-reverse items-center justify-around gap-4 ">
                    //             <div className=" w-full">
                    //               <input
                    //                 id={`amount-${i + 1}`}
                    //                 name={`amount-${i}`}
                    //                 type="text"
                    //                 value={previousIndex === i ? amount || '' : ''}
                    //                 onInput={(event) => {
                    //                   const { name, value } = event.target;
                    //                   const regex = /^(0|[1-9]\d*)(\.\d{1,2})?$/;
                    //                   if (regex.test(value) || value === '') {
                    //                     setPreviousIndex(i);
                    //                     setAmount(value);
                    //                   } else {
                    //                     event.target.value = value.replace(/\D/g, '');
                    //                   }
                    //                 }}
                    //                 className={`w-full ${projectGuID == _?.id ? 'focus:border-red-700 border border-red-600 focus:ring-2 focus:ring-red-600 rounded-full' : 'focus:border-customgreen border border-customgreen focus:ring-2 focus:ring-customgreen rounded-full'} border-customgreen focus:ring-2 focus:ring-customgreen rounded-full  `}
                    //                 placeholder={t('Enter Amount')}
                    //                 maxLength={6}
                    //                 min="0"
                    //                 disabled={_?.isContribution}
                    //               />
                    //             </div>
                    //             <div className="w-full">
                    //               <CounterApp
                    //                 index={i}
                    //                 previousIndex={previousIndex}
                    //                 setPreviousIndex={setPreviousIndex}
                    //                 currentIndex={currentIndex}
                    //                 setCurrentIndex={setCurrentIndex}
                    //                 count={count}
                    //                 setCount={setCount}
                    //                 amount={amount}
                    //                 setAmount={setAmount}
                    //                 price={_.price}
                    //               />
                    //             </div>
                    //           </div>

                    //           <p className="text-red-900 text-center">
                    //             {errorStates[i] && 'Amount Must be Greater Than 0'}
                    //           </p>

                    //           <div className="flex flex-col sxx:flex-row sm:flex-row md:flex-row lg:flex-row xl:flex-row items-center justify-around gap-3 ">
                    //             <button
                    //               className="w-full text-center text-white border border-white bg-customgreen hover:bg-hovergreen hover:text-white focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-lg p-1.5 flex justify-center items-center transition duration-700 ease-in-out"
                    //               onClick={() => {
                    //                 DonateHandle(_?.id, _?.id, _?.totalCost, i);
                    //                 _?.isContribution && setAmount(_?.isContribution ? _?.price : null);
                    //               }}
                    //             >
                    //               {t('Donate Now')}
                    //             </button>

                    //             <button
                    //               disabled={isLoading ? true : false}
                    //               onClick={() => {
                    //                 addCartItem(`${_?.id}`, '6');
                    //                 _?.isContribution == false &&
                    //                   setAmount(_?.isContribution == false ? _?.price : null);
                    //               }}
                    //               type="button"
                    //               className="w-full text-center text-white border border-white bg-customgreen hover:bg-hovergreen hover:text-white focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-lg p-2 flex justify-center items-center transition duration-700 ease-in-out"
                    //             >
                    //               <svg
                    //                 className="w-6 h-6"
                    //                 aria-hidden="true"
                    //                 xmlns="http://www.w3.org/2000/svg"
                    //                 fill="currentColor"
                    //                 viewBox="0 0 24 24"
                    //               >
                    //                 <path d="M10 20.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5zm3.5-1.5c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm6.304-17l-3.431 14h-2.102l2.541-11h-16.812l4.615 13h13.239l3.474-14h2.178l.494-2h-4.196z" />
                    //               </svg>

                    //               <span className="sr-only">Icon description</span>
                    //             </button>
                    //           </div>

                    //           {_?.isAltakamul && (
                    //             <div className="w-full pb-3">
                    //               <button
                    //                 className="w-full text-center text-white border border-white bg-customgreen hover:bg-hovergreen hover:text-white focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-lg p-1.5 flex justify-center items-center uppercase transition duration-700 ease-in-out"
                    //                 onClick={() => setSmsModal(true)}
                    //               >
                    //                 {t('sms')}
                    //               </button>
                    //             </div>
                    //           )}
                    //         </div>
                    //       </div>
                    //     </div>
                    //   </div>
                    // </>

                    // <ProjectsCard
                    //   key={i}
                    //   i={i}
                    //   data={data}
                    //   handleOnChange={handleOnChange}
                    //   handleShareLink={handleShareLink}
                    //   addCartItem={addCartItem}
                    //   DonateHandle={DonateHandle}
                    //   previousIndex={previousIndex}
                    //   setPreviousIndex={setPreviousIndex}
                    //   setCurrentIndex={setCurrentIndex}
                    //   setCount={setCount}
                    //   setAmount={setAmount}
                    //   amount={amount}
                    //   count={count}
                    //   currentIndex={currentIndex}
                    //   errorStates={errorStates}
                    //   isLoading={isLoading}
                    //   selectedValues={selectedValues}
                    //   setSmsModal={setSmsModal}
                    //   setProjectId={setProjectId}
                    // />
                    <CampaignsCard
                      key={i}
                      i={i}
                      data={data}
                      handleOnChange={handleOnChange}
                      handleShareLink={handleShareLink}
                      addCartItem={addCartItem}
                      DonateHandle={DonateHandle}
                      previousIndex={previousIndex}
                      setPreviousIndex={setPreviousIndex}
                      setCurrentIndex={setCurrentIndex}
                      setCount={setCount}
                      setAmount={setAmount}
                      amount={amount}
                      count={count}
                      currentIndex={currentIndex}
                      errorStates={errorStates}
                      isLoading={isLoading}
                      selectedValues={selectedValues}
                      setSmsModal={setSmsModal}
                      setProjectId={setProjectId}
                    />
                  );
                })
              ) : (
                <>
                  <DataNotFound />
                </>
              )}
              {
                <ModalCartSuccessful
                  modalMessageText={modalMessageText}
                  modalExist={modalExist}
                  setGridModalOpen={setGridModalOpen}
                  gridModalOpen={gridModalOpen}
                />
              }
              {<SMSModal smsModal={smsModal} setSmsModal={setSmsModal} projectId={projectId} />}
              {isLoading && <LoaderModal />}
            </div>
          </div>
        </div>
      ) : (
        <LoadingAnimation imageStyling={''} styling={'h-screen '} />
      )}
    </>
  );
};
